<img class="img-fluid w-100" *ngIf="isAssetPresent()" [src]="assetUrl()" alt="">
<div class="image-placeholder" *ngIf="!isAssetPresent()">
  <div>
    <i class="fa fa-image fa-4x"></i>
  </div>
</div>
